import { Box } from '@mui/material';
import { FC } from 'react';
import Lottie from "lottie-react";
import loaderAnimation from 'shared/animations/loaderAnimation.json';

interface ILoader {
    title: string;
}

export const Loader: FC<ILoader> = ({ title }) => {
    return (
        <Box style={{ display: 'flex', justifyContent: 'center', alignItems: 'center', height: '60vh', flexDirection: "column" }}>
            <Lottie
                animationData={loaderAnimation}
                loop={true}
                autoplay={true}
                style={{ width: 300, height: 300 }}
            />
            <p style={{ color: '#0054E6', fontSize: '20px', marginTop: '-60px' }}>{title}</p>
        </Box>
    );
};

export default Loader;
